// extracted by mini-css-extract-plugin
export default {"tickets-button":"ticket-notifications_tickets-button__ZK2hI"};